import React from "react";
import ProfileView from "./ProfileView";
export default function UserProfile() {
  return <ProfileView mode="other" />;
}
